import { useQueryClient } from '@tanstack/react-query';
import { useNavigate } from 'react-router-dom';
import { CheckScreen } from '@/features/check/CheckScreen';
import {
    resolveLoyaltyConfiguration,
    useLoyaltyConfiguration,
} from '@/features/loyalty/useLoyaltyConfiguration';
import { useCheckout } from './checkoutContext';

/** The itemisation, and the first step of checkout. */
export function CheckRoute() {
    const { location, check, accessToken } = useCheckout();
    const navigate = useNavigate();
    const queryClient = useQueryClient();

    /*
     * Asked while the guest is still reading their check, so the answer is already in hand when they tap Pay.
     * The same reasoning as the wallet probe at the tip step: this decides which screen comes next, and
     * asking at the moment of the tap would put a round trip in front of them.
     */
    useLoyaltyConfiguration(accessToken);

    const handlePay = async () => {
        const loyalty = await resolveLoyaltyConfiguration(queryClient, accessToken);

        // `enabled` already folds in whether the restaurant has a programme AND whether its POS can take the
        // discount. A guest must never reach a loyalty screen that could spend their points for nothing.
        navigate(loyalty?.enabled ? '/loyalty' : '/tip');
    };

    return <CheckScreen location={location} check={check} onPay={handlePay} />;
}
